var _defs, _rect, _rect2, _path, _path2, _circle, _circle2, _circle3, _rect3, _rect4, _rect5, _rect6, _path3, _rect7, _rect8, _rect9, _polyline, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _polyline2, _rect14, _rect15, _polyline3, _rect16, _rect17, _circle4, _rect18, _line, _circle5, _path4, _rect19, _path5, _line2, _line3, _path6, _path7, _polygon, _path8, _path9, _path0, _rect20, _circle6, _rect21, _path1, _circle7, _circle8, _circle9, _circle0, _circle1, _path10, _path11, _path12, _path13, _ellipse, _ellipse2, _path14, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _path15, _rect29, _path16, _path17, _path18, _path19, _path20, _path21, _rect30, _rect31, _rect32, _rect33, _path22, _path23, _rect34, _rect35, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _rect36, _ellipse3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWandLadyAndBrowser = (_ref, ref) => {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1549.68 1901.13",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Lady holding a wand and a web browser") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#efefef;}.cls-2{fill:#3ec1f3;stroke:#3ec1f3;opacity:0.4;}.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-2,.cls-8,.cls-9{stroke-miterlimit:10;}.cls-10,.cls-11,.cls-2,.cls-8,.cls-9{stroke-width:4.94px;}.cls-10,.cls-2{stroke-dasharray:18.46 18.46;}.cls-3{fill:#4756df;}.cls-4{fill:#ddd;}.cls-5{fill:#fa3b3c;}.cls-6{fill:#ffbe21;}.cls-7{fill:#22c67b;}.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-8,.cls-9{fill:none;}.cls-10,.cls-11,.cls-8,.cls-9{stroke:#ddd;}.cls-8{stroke-dasharray:18.62 18.62;}.cls-9{stroke-dasharray:18.2 18.2;}.cls-11{stroke-dasharray:18.51 18.51;}.cls-12{stroke:#4756df;stroke-width:2.47px;}.cls-13,.cls-16,.cls-17{stroke:#30252a;}.cls-13,.cls-14,.cls-17{stroke-width:7.41px;}.cls-14{stroke:#fa3b3c;}.cls-15{stroke:#ffbe21;stroke-width:6px;}.cls-16{stroke-width:6.17px;}.cls-17,.cls-21{fill:#fff;}.cls-17{stroke-linejoin:bevel;}.cls-18{fill:#e68f5b;}.cls-19{fill:#30252a;}.cls-20{fill:#84401e;}.cls-22{fill:#7784f5;}.cls-23{fill:#ffb7d5;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 829.87,
    width: 1438.22,
    height: 1071.27,
    rx: 60
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 933.4,
    y: 1274.91,
    width: 388.14,
    height: 273.89,
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M532.73,1688.25h768.8a20,20,0,0,1,20,20v122.36a0,0,0,0,1,0,0H512.73a0,0,0,0,1,0,0V1708.25A20,20,0,0,1,532.73,1688.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M60,829.87H1378.22a60,60,0,0,1,60,60v52.41a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V889.87A60,60,0,0,1,60,829.87Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 84.3,
    cy: 888.07,
    r: 19.21
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 141.78,
    cy: 888.07,
    r: 19.21
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 199.26,
    cy: 888.07,
    r: 19.21
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 466.57,
    y: 1014.04,
    width: 901.12,
    height: 168.07,
    rx: 30.86
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 70.53,
    y: 1012.81,
    width: 349.89,
    height: 168.07,
    rx: 30.86
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 466.57,
    y: 1228.27,
    width: 901.12,
    height: 602.33,
    rx: 30.86
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 70.53,
    y: 1228.27,
    width: 349.89,
    height: 602.33,
    rx: 30.86
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M141.23,1094.72c-7.67,8.54-15.61,17.59-18.23,28.76s2.21,25,13.19,28.34,21.85-4.6,30.27-12.32a441.34,441.34,0,0,0,68.48-79.87c2.84-4.26,5.53-10.22,2.13-14-4.08-4.58-11.57-.59-15.89,3.76-16.68,16.76-27,40.27-33.88,61.27-3,9.24-2.14,21.63,6.37,26.31,4.52,2.47,10.21,1.87,14.87-.31s8.51-5.75,12.27-9.26c11.47-10.7,20.48-20.61,31.95-31.31,3-2.84,8.46-7.39,12.58-8,20.55-2.78-6.59,70.32-21.75,59.5-10.76-7.67,22.17-37,36.07-49.52,23.62-21.24,31.78-4.14,28,11.18-3.29,13.49-9.71,42.45-19.85,38.76-9.24-3.36,47-73.56,80.79-75.45"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 116.69,
    y: 1274.43,
    width: 257.57,
    height: 274.37,
    rx: 20
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 116.69,
    y: 1629.59,
    width: 181.39,
    height: 26.13,
    rx: 10.58
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 116.69,
    y: 1581.33,
    width: 257.34,
    height: 26.13,
    rx: 10.58
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "322.77 1629.59 335.84 1642.65 322.77 1655.72"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 512.73,
    y: 1581.33,
    width: 388.14,
    height: 26.13,
    rx: 10.58
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 512.73,
    y: 1629.59,
    width: 191.41,
    height: 26.13,
    rx: 10.58
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 512.73,
    y: 1085.01,
    width: 138.71,
    height: 26.13,
    rx: 10.58
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 683.97,
    y: 1085.01,
    width: 154.1,
    height: 26.13,
    rx: 10.58
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 870.75,
    y: 1085.01,
    width: 125.29,
    height: 26.13,
    rx: 10.58
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1088.5,
    y: 1085.01,
    width: 125.29,
    height: 26.13,
    rx: 10.58
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "728.84 1629.59 741.9 1642.65 728.84 1655.72"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 933.4,
    y: 1581.33,
    width: 388.14,
    height: 26.13,
    rx: 10.58
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 933.4,
    y: 1629.59,
    width: 111.29,
    height: 26.13,
    rx: 10.58
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "1069.38 1629.59 1082.45 1642.65 1069.38 1655.72"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 116.69,
    y: 1688.25,
    width: 115.14,
    height: 115.14,
    rx: 20
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 259.12,
    y: 1688.25,
    width: 115.14,
    height: 115.14,
    rx: 20
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 1283.65,
    cy: 1098.08,
    r: 37.88
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 512.73,
    y: 1274.91,
    width: 388.14,
    height: 273.89,
    rx: 20
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 1418.11,
    y1: 1437.39,
    x2: 1481.08,
    y2: 1322.87
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1503.09,
    cy: 1492.92,
    r: 4.88
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1457.46,1446.35c9.49-15,13.83-21.7,23.39-30.27a23.49,23.49,0,0,1,7.34-4.84,10,10,0,0,1,8.53.51c4.25,2.65,4.83,8.57,4.41,13.57a70.24,70.24,0,0,1-4.36,19.12,13.58,13.58,0,0,1-3.25,5.44c-1.58,1.42-4,2.09-5.89,1.06a5.33,5.33,0,0,1-2.39-4.83,14.24,14.24,0,0,1,1.58-5.4c10-22.09,30.55-38.81,61.9-49.42"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 980.05,
    y: 1228.26,
    width: 388.14,
    height: 273.89,
    rx: 20
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1138.13,1342l24.53-43.73s10.92-23.58,23.82-19.18c12.07,4.12,6.57,20.52,6.57,20.52s10.67-16,23.73-9.6,4.27,27.19,4.27,27.19,10.54-8.79,19.43-4.11c9.8,5.16,3.59,21,1.74,24.94l-39.46,84.66a50.43,50.43,0,0,1-19.68,22.24c-11.38,6.75-28.58,10.71-51.92-.43-34.5-16.47-28.37-61.28-28.37-61.28l3.2-61.64s1.16-31.26,18.23-30.72,16.8,46,16.8,46"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 1193.05,
    y1: 1299.56,
    x2: 1170.17,
    y2: 1346.19
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 1221.05,
    y1: 1317.15,
    x2: 1198.63,
    y2: 1362.59
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1141,1336.8s30,25.79,7.66,60.18"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1124.22,1290.81s.55,30.87-18.23,30.72"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "1386.86 1551.92 1360.92 1590.99 1321.53 1443.48 1452.18 1517.24 1410.08 1532.56 1444.5 1574.05 1420.22 1593.64 1386.86 1551.92"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M973.77,835l-83.69,9.86S864.84,846,866.9,876.7L819.67,895s-21.41,7-16.12,21.16,31,6.55,31,6.55-6,23.93,44.59,16.12c0,0-8.8,18.24,25.12,21.87s110.57,5.59,110.57,5.59Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1276.43,315l22.11,124H1184.05l9.56-69c-41.24,1.1-83.1-9.43-107.69-43s-13.09-74.62-3.11-94.56c9-18,35.31-65.86,63.4-106.55q4.57-6.63,9.18-12.94c14.64-20,38.66-33.3,63.63-36.72h0c28.53-3.92,58.3,5,76.71,31.46,34.17,49.09,6,112.3,5.5,113.54"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1517.78,543.87,1480.93,661.6l-41,131.06-9.4,30s-17.31,54.61-36.6,76.46a106.26,106.26,0,0,1-36.06,26.48c-3.49,1.59-6.92,2.94-10.24,4.08-19.49,6.72-35,6.45-35,6.45l-98.72,10-11.66,1.18-187.45,18.94L973.77,835l34.1-14,4.79-99.34-19,17.71L904,822.81a105.59,105.59,0,0,1-16.82,11.32c-18.74,10.41-51.41,22.45-89.08,9.72-56.17-19-66.76-94.19-66.76-94.19l-16.17-73.55L684.46,536.47l-18.47-84,121.4-49.95,87.4,200.65,84.94-97.61,37-42.47s22.14-23.7,41.84-36c10.85-6.78,27.68-7.46,40.6-6.71a151.62,151.62,0,0,1,18.48,2.19L1184.05,439l5.06-36.53H1292l6.51,36.53,84.1-20.18,26.83-6.43s50.25-17.05,94.42,29.09a65,65,0,0,1,14.29,24C1530.35,500.72,1517.78,543.87,1517.78,543.87Z"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 1216.03,
    y: 191.6,
    width: 6,
    height: 25.17,
    transform: "translate(573.09 1257.98) rotate(-68)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 1174.68,
    cy: 616.26,
    r: 74.26
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 1133.5,
    y: 170.71,
    width: 6,
    height: 20.68,
    transform: "matrix(0.07, -1, 1, 0.07, 881.65, 1303.31)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1143.43,252.69c-3.74-2.88-5.65-6.21-5.69-9.89-.06-5.85,4.71-10,5.5-10.66l14-12.34,4,4.51-14.18,12.45c-.93.77-3.36,3.35-3.32,6,0,1.75,1.15,3.49,3.35,5.18Z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 1203.47,
    cy: 228.42,
    r: 3.89
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 1127.26,
    cy: 205,
    r: 3.89
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 989.03,
    cy: 104.81,
    r: 3.14
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 746.7,
    cy: 60.76,
    r: 3.14
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 948.84,
    cy: 10.48,
    r: 3.14
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1164.24,274.25a14,14,0,0,1-4.41-.69,12,12,0,0,1-5.27-3.42l2.33-1.89,2.29-1.93c.39.44,4,4.23,11.89-.13,6.87-3.82,10.69-12.68,10.73-12.76l5.53,2.34c-.19.44-4.69,10.86-13.34,15.66A20,20,0,0,1,1164.24,274.25Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1193.76,373l-.3-6c.18,0,19-1,32.25-7.19l2.53,5.44C1214,371.93,1194.57,373,1193.76,373Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1301.24,221.21h0s-93.28,26.64-82.2-145c28.53-3.92,58.3,5,76.71,31.46C1329.91,156.76,1301.79,220,1301.24,221.21Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1219,76.21c-.7.89-50.37,64.33-72.81,49.66q4.57-6.63,9.18-12.94C1170,92.9,1194.05,79.63,1219,76.21Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-19",
    cx: 1328.99,
    cy: 349.59,
    rx: 74.84,
    ry: 63.02,
    transform: "translate(300.55 1261.04) rotate(-56.29)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-19",
    cx: 1375.52,
    cy: 539.12,
    rx: 46.34,
    ry: 39.94,
    transform: "translate(-101.86 532.72) rotate(-21.15)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1301.24,221.21h0s54-11.14,47.76,36c-7.53,57.35-72.56,57.86-72.56,57.86"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 1292.64,
    y: 253.68,
    width: 35.17,
    height: 6,
    transform: "translate(-24.84 270.17) rotate(-11.66)"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 846.2,
    y: 613.26,
    width: 34.6,
    height: 6,
    transform: "translate(-166.98 868.28) rotate(-49.26)"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 935.11,
    y: 636.65,
    width: 164.33,
    height: 6,
    transform: "translate(321.35 1619.29) rotate(-86.77)"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 1216.33,
    y: 649.44,
    width: 139.86,
    height: 6,
    transform: "translate(256.18 1661.93) rotate(-71.32)"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 1167.08,
    y: 450.46,
    width: 29.26,
    height: 6,
    transform: "translate(544.82 1547.28) rotate(-80.78)"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 833.68,
    y: 912.85,
    width: 55.68,
    height: 6,
    transform: "translate(-198.12 238.97) rotate(-14.18)"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 878.91,
    y: 933.28,
    width: 31.51,
    height: 6,
    transform: "translate(-137.87 154.67) rotate(-9.18)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M844.81,919.62a9,9,0,0,0-4.63-6.39c-4.65-2.65-14.57-3.81-35.39,5.62l-2.48-5.46c18.7-8.47,32.5-10.25,41-5.28a15,15,0,0,1,7.46,10.94l-6,.53,3-.26Z"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 865.07,
    y: 862.94,
    width: 65.33,
    height: 6,
    transform: "translate(-235.26 344.31) rotate(-19.25)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M787.39,402.49l-14.46-73s-4-22.85-11.09-31.68S727,261.06,727,261.06s-18.1-19.43-27.52-8.1,0,25.17,0,25.17-8.87-8.26-14.46-9.76c-6.64-1.79-24.06-1.05-29.11,5.58S652,290.86,652,290.86s-27.54-3.68-20.06,26.59c0,0-10.12-3.51-9.87,10.14s7.56,64.71,7.56,64.71,2.54,14,14.37,12.92,10.73-17.11,10.73-17.11L666,452.45"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M737.46,332c-23.91-17.87-40.06-51.13-40.73-52.54l5.4-2.6c.16.33,16.21,33.35,38.92,50.34Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M726.92,277.74a16.64,16.64,0,0,1-2.52-.19c-14.51-2.1-27-22.16-27.52-23l5.11-3.14c3.17,5.15,13.54,18.82,23.28,20.23a11,11,0,0,0,9.25-3.08l4,4.47A17.09,17.09,0,0,1,726.92,277.74Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M679,388.08c-8.88,0-15.22-7.06-17.66-11.63l-32-57.55,5.25-2.91,32,57.59c.28.51,6.41,11.56,16.82,7.64,6.29-2.37,5-15.67,4-20.14l5.87-1.27c.19.91,4.69,22.34-7.75,27A18.41,18.41,0,0,1,679,388.08Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M705.58,371.9c-7.84,0-14.54-5.63-17.61-9.62l-.19-.27-36-59.2C648.82,297.52,649,291,649,290.76l6,.21-3-.11,3,.1a20.14,20.14,0,0,0,2,8.89l35.83,58.88c1,1.24,9.33,11,18.54,5.46a7.35,7.35,0,0,0,3.58-4.84c1.33-5.8-2.9-14-4.64-16.72l-23.51-37.18,5.07-3.2,23.49,37.15c.29.45,7.6,11.86,5.44,21.3a13.25,13.25,0,0,1-6.33,8.63A16.92,16.92,0,0,1,705.58,371.9Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M710.27,368.21c-9.83-17.82-16.61-20.72-19.79-20.87a6.17,6.17,0,0,0-5.07,2.54l-5-3.27a12.21,12.21,0,0,1,10.23-5.27c7.9.27,16.28,8.33,24.91,24Z"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 651.13,
    y: 368.89,
    width: 6,
    height: 19.24,
    transform: "translate(-23.12 43.11) rotate(-3.71)"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 707.97,
    y: 212.64,
    width: 141.05,
    height: 6,
    transform: "translate(182.01 760.4) rotate(-57.89)"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 700.48,
    y: 317.2,
    width: 24.79,
    height: 6,
    transform: "translate(62.72 753.8) rotate(-57.89)"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 566.95,
    y: 439.39,
    width: 138.5,
    height: 6,
    transform: "translate(-76.7 746.09) rotate(-57.89)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M798,185.38l1.74,55.9a4.76,4.76,0,0,0,9.2,1.59l21.28-54.33,47.69,28.12a4.76,4.76,0,0,0,6.22-7L850.9,165.43l46.2-26a4.76,4.76,0,0,0-2.91-8.88l-55.9,6.87.49-54.52a4.77,4.77,0,0,0-9.17-1.86l-20.37,49.37-49-25.65a4.76,4.76,0,0,0-6,7.16l33.2,42.3-48.75,30.41a4.76,4.76,0,0,0,3.2,8.75Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M883,103.35,878,100C890.45,81.52,908.26,66.19,923.4,61c6.47-2.24,12.23-2.12,16.38.26C947,53.6,956,47.52,965.15,42c16-9.64,31.4-15.28,51.49-18.87l1.06,5.91c-19.33,3.45-34.12,8.86-49.45,18.1-8.75,5.27-17.42,11.08-24.17,18.25a15.17,15.17,0,0,1,1.53,10.9c-.52,2.44-5.09,15.49-10.59,18.52a5.26,5.26,0,0,1-4.51.43,5.81,5.81,0,0,1-3.3-3.23c-1.38-3.11-.89-8.1,1.35-13.69a51.48,51.48,0,0,1,7.18-12.42c-3.72-1.36-8.67.11-10.38.7C911.38,71.46,894.74,85.88,883,103.35Zm56.76-32.77a44.23,44.23,0,0,0-5.61,10c-1.87,4.66-1.86,7.6-1.57,8.73,2.31-1.87,6.39-10.52,7.17-14.22A10.94,10.94,0,0,0,939.75,70.58Z"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 851.05,
    y: 33.77,
    width: 79.21,
    height: 6,
    transform: "translate(459.68 817.08) rotate(-63.45)"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 795.65,
    y: 2.42,
    width: 6,
    height: 62.03,
    transform: "translate(8.08 151.6) rotate(-10.9)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1480.93,661.6l-41,131.06q-3.2.29-6.46.28a74.26,74.26,0,1,1,47.49-131.34Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1518.18,465.55a74.26,74.26,0,0,1-135.71-41.7c0-1.68.06-3.35.17-5l26.83-6.43s50.25-17.05,94.42,29.09A65,65,0,0,1,1518.18,465.55Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1357.84,925.63c-3.49,1.59-6.92,2.94-10.24,4.08-19.49,6.72-35,6.45-35,6.45l-98.72,10a74.27,74.27,0,0,1,143.92-20.5Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1181.71,780.91a74.27,74.27,0,0,1-143.12,27.84l137.94-55.15A74.16,74.16,0,0,1,1181.71,780.91Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M793.73,602a74.26,74.26,0,0,1-74.26,74.26c-1.44,0-2.88,0-4.3-.13L684.46,536.47A74.29,74.29,0,0,1,793.73,602Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1086.91,453.47a74.25,74.25,0,0,1-127.18,52.07l37-42.47s22.14-23.7,41.84-36c10.85-6.78,27.68-7.46,40.6-6.71A73.92,73.92,0,0,1,1086.91,453.47Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M993.63,739.4,904,822.81a105.59,105.59,0,0,1-16.82,11.32A74.26,74.26,0,1,1,993.63,739.4Z"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 996.61,
    y: 759.52,
    width: 315.23,
    height: 6,
    transform: "translate(-200.58 482.92) rotate(-21.79)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-19",
    cx: 1382.47,
    cy: 446.92,
    rx: 64.8,
    ry: 52.84,
    transform: "translate(141.47 1202.49) rotate(-49.25)"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWandLadyAndBrowser);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "wand-lady-and-browser.1a515ca.svg";